import React from 'react';
import { colors as theme } from '../theme';

const TermsOfService = ({ onBack }) => {
  return (
    <div style={{
      backgroundColor: theme.surface1, minHeight: '100vh',
      padding: '30px', maxWidth: '720px', margin: '0 auto',
      fontFamily: "'Inter', sans-serif", color: theme.text, lineHeight: '1.7'
    }}>
      <button
        onClick={onBack}
        style={{
          background: 'transparent', border: `1px solid ${theme.surface3}`,
          color: theme.gold, padding: '8px 16px', borderRadius: '8px',
          cursor: 'pointer', fontSize: '14px', marginBottom: '28px'
        }}
      >
        ← Back
      </button>

      <h1 style={{ color: theme.gold, fontSize: '28px', marginBottom: '4px' }}>Terms of Service</h1>
      <p style={{ color: theme.textMuted, fontSize: '13px', marginBottom: '28px' }}>
        The Atone Academy · Last updated: February 2026
      </p>

      <Section title="1. Acceptance">
        <p>
          By creating an account and using The Atone Academy platform ("the App"), you agree to these Terms of Service.
          If you do not agree, please do not use the App.
        </p>
      </Section>

      <Section title="2. Eligibility">
        <p>
          You must be at least 16 years old to use this App. By signing up you confirm you meet this requirement.
          New client accounts require approval from an administrator before access is granted.
        </p>
      </Section>

      <Section title="3. Your Account">
        <ul>
          <li>You are responsible for keeping your login credentials secure.</li>
          <li>You must not share your account with others.</li>
          <li>You must provide accurate information when signing up.</li>
          <li>We reserve the right to suspend or terminate accounts that violate these terms.</li>
        </ul>
      </Section>

      <Section title="4. Use of the Service">
        <p>You agree to use the App only for its intended purpose — tracking your fitness training under the guidance of a coach. You must not:</p>
        <ul>
          <li>Attempt to access other users' data</li>
          <li>Interfere with the App's operation or security</li>
          <li>Upload unlawful, harmful, or offensive content</li>
          <li>Use the App for any commercial purpose without written permission</li>
        </ul>
      </Section>

      <Section title="5. Health Disclaimer">
        <p>
          The training programs and information provided in this App are for fitness purposes only and do not constitute
          medical advice. Always consult a qualified healthcare professional before starting a new exercise programme,
          especially if you have any medical conditions or injuries.
        </p>
        <p>
          The Atone Academy and its coaches are not liable for any injury or health issue arising from your use of the App
          or the training programs provided.
        </p>
      </Section>

      <Section title="6. Content You Submit">
        <p>
          By submitting check-in photos, messages, or other content, you grant The Atone Academy a limited licence to
          store and display that content to authorised users (your coach and admins) within the platform.
          We will not share your content publicly or with third parties without your consent.
        </p>
      </Section>

      <Section title="7. Termination">
        <p>
          You may request deletion of your account at any time via the Settings page.
          We may suspend or terminate your account if you breach these terms or misuse the platform.
        </p>
      </Section>

      <Section title="8. Limitation of Liability">
        <p>
          The Atone Academy provides the App "as is" without warranty. To the maximum extent permitted by law,
          we are not liable for any indirect, incidental, or consequential damages arising from your use of the App.
        </p>
      </Section>

      <Section title="9. Changes to These Terms">
        <p>
          We may update these terms from time to time. Continued use of the App after changes are posted
          constitutes acceptance of the revised terms.
        </p>
      </Section>

      <Section title="10. Contact">
        <p>
          For any questions about these terms, contact us at:{' '}
          <span style={{ color: theme.gold }}>theatoneacademy@gmail.com</span>
        </p>
      </Section>
    </div>
  );
};

const Section = ({ title, children }) => (
  <div style={{ marginBottom: '24px' }}>
    <h2 style={{ color: theme.gold, fontSize: '16px', marginBottom: '10px' }}>{title}</h2>
    <div style={{ color: '#CCCCCC', fontSize: '14px' }}>{children}</div>
  </div>
);

export default TermsOfService;
